import {BannerViewType} from '../../../graphql/generated/types';
import {getImageRatio} from '../../atoms/Image/getImageRatio.function';

export const BIG_BANNER_RATIO: {[key in BannerViewType]: number} = {
  [BannerViewType.Square]: 1,
  [BannerViewType.Rectangle]: getImageRatio({width: 16, height: 9}),
  [BannerViewType.Unknown]: 1,
};
